import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Announcement, AnnouncementService } from '../../services/announcement.service';

export interface AnnouncementPopupData {
  announcements: Announcement[];
  employeeId: string;
}

@Component({
  selector: 'app-announcement-popup',
  templateUrl: './announcement-popup.component.html',
  styleUrls: ['./announcement-popup.component.css']
})
export class AnnouncementPopupComponent {
  index = 0;

  constructor(
    private dialogRef: MatDialogRef<AnnouncementPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AnnouncementPopupData,
    private announcementService: AnnouncementService
  ) {}

  get announcements(): Announcement[] {
    return this.data.announcements || [];
  }

  get current(): Announcement | null {
    return this.announcements[this.index] || null;
  }

  get total(): number {
    return this.announcements.length;
  }

  get isLast(): boolean {
    return this.index >= this.total - 1;
  }

  private markCurrent(): void {
    const a = this.current;
    if (a && a.announcementId != null && this.data.employeeId) {
      this.announcementService.markViewed(a.announcementId, this.data.employeeId).subscribe({ error: () => {} });
    }
  }

  next(): void {
    this.markCurrent();
    if (this.isLast) {
      this.dialogRef.close();
    } else {
      this.index++;
    }
  }

  dismissAll(): void {
    this.announcements.forEach(a => {
      if (a.announcementId != null && this.data.employeeId) {
        this.announcementService.markViewed(a.announcementId, this.data.employeeId).subscribe({ error: () => {} });
      }
    });
    this.dialogRef.close();
  }
}
